window.overlay       = $('#overlay');
window.hash          = window.location.hash;
window.mappacaricata = false;



// WEBPACK FOOTER //
// ./resources/assets/js/variabili.js